import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { ItemsService } from "../../../../services/items.service";
import { RenderedService } from "../../rendered.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-phone-number",
  templateUrl: "./phone-number.component.html",
  styleUrls: ["../../rendered.component.scss", "./phone-number.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneNumberComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Output() changed = new EventEmitter<any>();
  public destroy$: Subject<boolean> = new Subject<boolean>();
  phoneNumber = {
    cc: "+1",
    areaCode: "",
    subscriberNumber: "",
    e164Number: "",
  };

  countryCodes;
  constructor(
    public cdr: ChangeDetectorRef,
    private itemsService: ItemsService,
    public renderedService: RenderedService,
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.update();

    this.itemsService
      .registerItem(this.info)
      .pipe(takeUntil(this.destroy$))
      .subscribe((d) => {
        this.cdr.detectChanges();
      });
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  numberChanged() {
    this.phoneNumber.e164Number = this.phoneNumber.cc;

    if (this.phoneNumber.areaCode) {
      this.phoneNumber.areaCode = this.phoneNumber.areaCode.replace(/\D/g, "");
      var tempAreaCodeNums = this.phoneNumber.areaCode.match(/\d/g);
      this.phoneNumber.e164Number += tempAreaCodeNums.join("");
    }

    if (this.phoneNumber.subscriberNumber) {
      this.phoneNumber.subscriberNumber =
        this.phoneNumber.subscriberNumber.replace(/\D/g, "");
      var tempPhoneNums = this.phoneNumber.subscriberNumber.match(/\d/g);
      this.phoneNumber.e164Number += tempPhoneNums.join("");
    }

    this.changed.emit({ value: this.phoneNumber });
  }

  update() {
    this.countryCodes = this.getCountryCodes();

    this.phoneNumber = this.value || null;

    if (typeof this.phoneNumber == "string" || this.phoneNumber == null) {
      this.phoneNumber = {
        cc: "+1",
        areaCode: "",
        subscriberNumber: "",
        e164Number: "",
      };
    }
    this.cdr.detectChanges();
  }

  private getCountryCodes() {
    return [
      { value: "+1", name: "United States, Canada +1" },
      { value: "+20", name: "Egypt +20" },
      { value: "+211", name: "South Sudan +211" },
      { value: "+212", name: "Morocco +212" },
      { value: "+213", name: "Algeria +213" },
      { value: "+216", name: "Tunisia +216" },
      { value: "+218", name: "Libya +218" },
      { value: "+220", name: "Gambia +220" },
      { value: "+221", name: "Senegal +221" },
      { value: "+222", name: "Mauritania +222" },
      { value: "+223", name: "Mali +223" },
      { value: "+224", name: "Guinea +224" },
      { value: "+225", name: "Ivory Coast +225" },
      { value: "+226", name: "Burkina Faso +226" },
      { value: "+227", name: "Niger +227" },
      { value: "+228", name: "Togo +228" },
      { value: "+229", name: "Benin +229" },
      { value: "+230", name: "Mauritius +230" },
      { value: "+231", name: "Liberia +231" },
      { value: "+232", name: "Sierra Leone +232" },
      { value: "+233", name: "Ghana +233" },
      { value: "+234", name: "Nigeria +234" },
      { value: "+235", name: "Chad +235" },
      { value: "+236", name: "Central African Republic +236" },
      { value: "+237", name: "Cameroon +237" },
      { value: "+238", name: "Cape Verde +238" },
      { value: "+239", name: "São Tomé and Príncipe +239" },
      { value: "+240", name: "Equatorial Guinea +240" },
      { value: "+241", name: "Gabon +241" },
      { value: "+242", name: "Republic of the Congo +242" },
      { value: "+243", name: "Democratic Republic of the Congo +243" },
      { value: "+244", name: "Angola +244" },
      { value: "+245", name: "Guinea-Bissau +245" },
      { value: "+246", name: "British Indian Ocean Territory +246" },
      { value: "+247", name: "Ascension Island +247" },
      { value: "+248", name: "Seychelles +248" },
      { value: "+249", name: "Sudan +249" },
      { value: "+250", name: "Rwanda +250" },
      { value: "+251", name: "Ethiopia +251" },
      { value: "+252", name: "Somalia +252" },
      { value: "+253", name: "Djibouti +253" },
      { value: "+254", name: "Kenya +254" },
      { value: "+255", name: "Tanzania +255" },
      { value: "+255", name: "Zanzibar +255" },
      { value: "+256", name: "Uganda +256" },
      { value: "+257", name: "Burundi +257" },
      { value: "+258", name: "Mozambique +258" },
      { value: "+260", name: "Zambia +260" },
      { value: "+261", name: "Madagascar +261" },
      { value: "+262", name: "Réunion +262" },
      { value: "+262", name: "Mayotte +262" },
      { value: "+263", name: "Zimbabwe +263" },
      { value: "+264", name: "Namibia +264" },
      { value: "+265", name: "Malawi +265" },
      { value: "+266", name: "Lesotho +266" },
      { value: "+267", name: "Botswana +267" },
      { value: "+268", name: "Eswatini +268" },
      { value: "+269", name: "Comoros  +269" },
      { value: "+27", name: "South Africa +27" },
      { value: "+290", name: "Saint Helena +290" },
      { value: "+290", name: "Tristan da Cunha +290" },
      { value: "+291", name: "Eritrea +291" },
      { value: "+297", name: "Aruba +297" },
      { value: "+298", name: "Faroe Islands +298" },
      { value: "+299", name: "Greenland +299" },
      { value: "+30", name: "Greece +30" },
      { value: "+31", name: "Netherlands +31" },
      { value: "+32", name: "Belgium +32" },
      { value: "+33", name: "France +33" },
      { value: "+34", name: "Spain +34" },
      { value: "+350", name: "Gibraltar +350" },
      { value: "+351", name: "Portugal +351" },
      { value: "+352", name: "Luxembourg +352" },
      { value: "+353", name: "Ireland +353" },
      { value: "+354", name: "Iceland +354" },
      { value: "+355", name: "Albania +355" },
      { value: "+356", name: "Malta +356" },
      { value: "+357", name: "Cyprus +357" },
      { value: "+358", name: "Finland +358" },
      { value: "+359", name: "Bulgaria +359" },
      { value: "+36", name: "Hungary +36" },
      { value: "+370", name: "Lithuania +370" },
      { value: "+371", name: "Latvia +371" },
      { value: "+372", name: "Estonia +372" },
      { value: "+373", name: "Moldova +373" },
      { value: "+374", name: "Armenia +374" },
      { value: "+374", name: "Artsakh +374" },
      { value: "+375", name: "Belarus +375" },
      { value: "+376", name: "Andorra +376" },
      { value: "+377", name: "Monaco +377" },
      { value: "+378", name: "San Marino +378" },
      { value: "+379", name: "Vatican City +379" },
      { value: "+380", name: "Ukraine +380" },
      { value: "+381", name: "Serbia +381" },
      { value: "+382", name: "Montenegro +382" },
      { value: "+383", name: "Kosovo +383" },
      { value: "+385", name: "Croatia +385" },
      { value: "+386", name: "Slovenia +386" },
      { value: "+387", name: "Bosnia and Herzegovina +387" },
      { value: "+389", name: "North Macedonia +389" },
      { value: "+39", name: "Italy +39" },
      { value: "+40", name: "Romania +40" },
      { value: "+41", name: "Switzerland +41" },
      { value: "+420", name: "Czech Republic +420" },
      { value: "+421", name: "Slovakia +421" },
      { value: "+423", name: "Liechtenstein +423" },
      { value: "+43", name: "Austria +43" },
      { value: "+44", name: "United Kingdom +44" },
      { value: "+45", name: "Denmark +45" },
      { value: "+46", name: "Sweden +46" },
      { value: "+47", name: "Norway +47" },
      { value: "+48", name: "Poland +48" },
      { value: "+49", name: "Germany +49" },
      { value: "+500", name: "Falkland Islands +500" },
      { value: "+501", name: "Belize +501" },
      { value: "+502", name: "Guatemala +502" },
      { value: "+503", name: "El Salvador +503" },
      { value: "+504", name: "Honduras +504" },
      { value: "+505", name: "Nicaragua +505" },
      { value: "+506", name: "Costa Rica +506" },
      { value: "+507", name: "Panama +507" },
      { value: "+508", name: "Saint-Pierre and Miquelon +508" },
      { value: "+509", name: "Haiti +509" },
      { value: "+51", name: "Peru +51" },
      { value: "+52", name: "Mexico +52" },
      { value: "+53", name: "Cuba +53" },
      { value: "+54", name: "Argentina +54" },
      { value: "+55", name: "Brazil +55" },
      { value: "+56", name: "Chile +56" },
      { value: "+57", name: "Colombia +57" },
      { value: "+58", name: "Venezuela +58" },
      {
        value: "+590",
        name: "Guadeloupe (including Saint Barthélemy, Saint Martin) +590",
      },
      { value: "+591", name: "Bolivia +591" },
      { value: "+592", name: "Guyana +592" },
      { value: "+593", name: "Ecuador +593" },
      { value: "+594", name: "French Guiana +594" },
      { value: "+595", name: "Paraguay +595" },
      { value: "+596", name: "Martinique  +596" },
      { value: "+597", name: "Suriname +597" },
      { value: "+598", name: "Uruguay +598" },
      { value: "+60", name: "Malaysia +60" },
      { value: "+61", name: "Australia +61" },
      { value: "+62", name: "Indonesia +62" },
      { value: "+63", name: "Philippines +63" },
      { value: "+64", name: "New Zealand +64" },
      { value: "+64", name: "Pitcairn Islands +64" },
      { value: "+65", name: "Singapore +65" },
      { value: "+66", name: "Thailand +66" },
      { value: "+672", name: "Australian External Territories  +672" },
      { value: "+672", name: "Australia Australian Antarctic Territory +672" },
      { value: "+672", name: "Norfolk Island +672" },
      { value: "+673", name: "Brunei +673" },
      { value: "+674", name: "Nauru +674" },
      { value: "+675", name: "Papua New Guinea +675" },
      { value: "+676", name: "Tonga +676" },
      { value: "+677", name: "Solomon Islands +677" },
      { value: "+678", name: "Vanuatu +678" },
      { value: "+679", name: "Fiji +679" },
      { value: "+680", name: "Palau +680" },
      { value: "+681", name: "Wallis and Futuna +681" },
      { value: "+682", name: "Cook Islands +682" },
      { value: "+683", name: "Niue +683" },
      { value: "+685", name: "Samoa +685" },
      { value: "+686", name: "Kiribati +686" },
      { value: "+687", name: "New Caledonia +687" },
      { value: "+688", name: "Tuvalu +688" },
      { value: "+689", name: "French Polynesia +689" },
      { value: "+690", name: "Tokelau +690" },
      { value: "+691", name: "Federated States of Micronesia +691" },
      { value: "+692", name: "Marshall Islands +692" },
      { value: "+7", name: "Russia +7" },
      { value: "+81", name: "Japan +81" },
      { value: "+82", name: "South Korea +82" },
      { value: "+84", name: "Vietnam +84" },
      { value: "+850", name: "North Korea +850" },
      { value: "+852", name: "Hong Kong +852" },
      { value: "+853", name: "Macau +853" },
      { value: "+855", name: "Cambodia +855" },
      { value: "+856", name: "Laos +856" },
      { value: "+86", name: "China +86" },
      { value: "+880", name: "Bangladesh +880" },
      { value: "+886", name: "Taiwan +886" },
      { value: "+90", name: "Turkey +90" },
      { value: "+91", name: "India +91" },
      { value: "+92", name: "Pakistan +92" },
      { value: "+93", name: "Afghanistan +93" },
      { value: "+94", name: "Sri Lanka +94" },
      { value: "+95", name: "Myanmar +95" },
      { value: "+960", name: "Maldives +960" },
      { value: "+961", name: "Lebanon +961" },
      { value: "+962", name: "Jordan +962" },
      { value: "+963", name: "Syria +963" },
      { value: "+964", name: "Iraq +964" },
      { value: "+965", name: "Kuwait +965" },
      { value: "+966", name: "Saudi Arabia +966" },
      { value: "+967", name: "Yemen +967" },
      { value: "+968", name: "Oman +968" },
      { value: "+970", name: "Palestine +970" },
      { value: "+971", name: "United Arab Emirates +971" },
      { value: "+972", name: "Israel +972" },
      { value: "+973", name: "Bahrain +973" },
      { value: "+974", name: "Qatar +974" },
      { value: "+975", name: "Bhutan +975" },
      { value: "+976", name: "Mongolia +976" },
      { value: "+977", name: "Nepal +977" },
      { value: "+98", name: "Iran +98" },
      { value: "+992", name: "Tajikistan +992" },
      { value: "+993", name: "Turkmenistan +993" },
      { value: "+994", name: "Azerbaijan +994" },
      { value: "+995", name: "Georgia +995" },
      { value: "+996", name: "Kyrgyzstan +996" },
      { value: "+998", name: "Uzbekistan +998" },
    ];
  }
}
